import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WalletSpinner from '../../components/wallet-spinner';
import REDIRECT_TIMEOUT from '../../lib/redirect-utils';

class PrequalAmex extends Component {
  componentDidMount() {
    // Returns the first match for an opening '<form...>' tag with 'redirectForm'
    const htmlForm = this.props.product.american_express.html.match(
      /<form.*redirectForm.*?>/
    )[0];
    const container = document.createElement('div');
    container.innerHTML = htmlForm;
    const url = container.children[0].getAttribute('action');

    if (!this.props.suppressRedirect) {
      setTimeout(() => {
        window.location.href = url;
      }, REDIRECT_TIMEOUT);
    }
  }

  render() {
    return (
      <div className="redirect-holder">
        <WalletSpinner />
        {this.props.suppressRedirect && <p>Redirect suppressed.</p>}
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
PrequalAmex.propTypes = {
  product: PropTypes.shape({
    american_express: PropTypes.shape({
      html: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  suppressRedirect: PropTypes.bool,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
PrequalAmex.displayName = 'PrequalAmex';

export default PrequalAmex;
